import script from "./reConfirmPwd.vue?vue&type=script&setup=true&name=confirmPwdMngTab&lang=js"
export * from "./reConfirmPwd.vue?vue&type=script&setup=true&name=confirmPwdMngTab&lang=js"

const __exports__ = script;

export default __exports__